<template>
    <div>
        <div class="col-12 px-0">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h1 class="h3 mb-0 text-gray-800">
                    {{ $t("Suportes") }}
                </h1>
            </div>
        </div>

        <b-card class="shadow">
            <div class="row">
                <div class="col-12">
                    <div
                        class="d-flex align-items-center justify-content-between mb-4"
                    >
                        <div>
                            <router-link
                                class="btn btn-primary"
                                to="/dashboard/admin/suportes/add"
                            >
                                <i class="fas fa-plus-square" />
                                {{ $t("Cadastrar") }}
                            </router-link>
                        </div>
                        <div>
                            <b-button-group>
                                <b-button
                                    variant="outline-dark"
                                    @click="getSuportes"
                                    v-b-tooltip.hover
                                    title="Atualizar Suportes"
                                >
                                    <i class="fas fa-sync"></i>
                                </b-button>

                                <b-button
                                    variant="outline-dark"
                                    @click="changeSort"
                                    v-b-tooltip.hover
                                    title="Ordenar por Data de Cadastro"
                                >
                                    <i
                                        v-show="sort.order === 'asc'"
                                        class="fas fa-sort-amount-up-alt"
                                    ></i>
                                    <i
                                        v-show="sort.order === 'desc'"
                                        class="fas fa-sort-amount-down-alt"
                                    ></i>
                                </b-button>

                                <b-button
                                    variant="outline-dark"
                                    :class="
                                        viewFilterReport === true
                                            ? 'active'
                                            : ''
                                    "
                                    @click="viewFilters"
                                    v-b-tooltip.hover
                                    title="Filtros para combinação de pesquisa"
                                >
                                    <i class="fas fa-filter"></i>
                                </b-button>
                            </b-button-group>
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="viewFilterReport">
                    <form @submit.prevent="getSuportes" ref="addItem">
                        <div class="row">
                            <div class="col-6">
                                <label><b>Pesquisar por Assunto</b></label>
                                <div class="input-group">
                                    <b-input
                                        placeholder="Pesquisar por Assunto"
                                        class="form-control search-input"
                                        type="text"
                                        v-model="filters.search"
                                        v-on:change="getSuportes"
                                        aria-describedby="input-search"
                                    />
                                    <div
                                        class="input-group-append"
                                        role="button"
                                    >
                                        <span
                                            class="input-group-text"
                                            id="input-search"
                                            ><i
                                                class="fas fa-search search-icon"
                                        /></span>
                                    </div>
                                </div>
                            </div>
                            <form-select
                                v-model="filters.remetente"
                                label="Solicitante"
                                grid="6"
                                :itens="solicitantes"
                            />

                            <form-select
                                v-model="filters.departments"
                                label="Departamento"
                                grid="6"
                                :itens="departamentos"
                                :disabled="disabledDepartamentos"
                                :loading="disabledDepartamentos"
                                multiple
                            />
                            <form-select
                                v-model="filters.statuses"
                                label="Status"
                                grid="6"
                                :itens="status"
                                multiple
                                :disabled="disabledStatus"
                                :loading="disabledStatus"
                            />

                            <form-calendar
                                v-model="data_inicio"
                                grid="6"
                                label="Data de Inicial"
                            />

                            <form-calendar
                                v-model="data_fim"
                                grid="6"
                                label="Data final"
                                :required="verificaDataInicial"
                            />
                        </div>
                        <div
                            class="row pt-4 mb-4 px-0 d-flex justify-content-end"
                        >
                            <div class="col-auto px-2 text-right">
                                <button
                                    class="btn btn-default"
                                    @click="viewFilters"
                                >
                                    <i class="fas fa-times"></i>
                                </button>

                                <button
                                    type="button"
                                    class="btn btn-secondary"
                                    @click="limparFiltros()"
                                >
                                    {{ $t("Limpar Filtros") }}
                                </button>

                                <button
                                    class="btn btn-success btn-submit"
                                    data-style="zoom-in"
                                    type="submit"
                                >
                                    <i class="fas fa-chart-bar"></i>
                                    {{ $t("Gerar Relatório") }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-12">
                    <p>
                        Período de pesquisa selecionado:
                        <b>{{ datas.start }} - {{ datas.end }}</b>
                        <b-link
                            href="#"
                            @click.prevent="void 0"
                            class="mb-2"
                            variant="info"
                            v-b-popover.hover.top="
                                'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                            "
                        >
                            <i class="fas fa-info-circle"></i>
                        </b-link>
                    </p>
                </div>
                <div class="col-12">
                    <b-card class="mb-3" no-body>
                        <loading-animation
                            :active.sync="loading"
                            :is-full-page="false"
                            :opacity="1"
                            color="#5895FF"
                        />
                        <b-table
                            :fields="[
                                {
                                    key: 'user',
                                    label: $t('Detalhes'),
                                },
                                {
                                    key: 'subject',
                                    label: $t('Assunto'),
                                },
                                {
                                    key: 'status',
                                    label: $t('Status'),
                                },
                                {
                                    key: 'created_at',
                                    label: $t('Datas'),
                                },
                                {
                                    key: 'actions',
                                    label: '',
                                    class: 'text-right',
                                },
                            ]"
                            :items="suportesList"
                            :responsive="true"
                            striped
                            stacked="md"
                            hover
                            show-empty
                            small
                            outlined
                            table-class="mb-0"
                        >
                            <template v-slot:cell(user)="data">
                                Protocolo: <b> #{{ data.item.id }} </b><br />
                                <span v-if="data.item.user_remetente != ''">
                                    Solicitante:
                                    <b>
                                        {{
                                            data.item.user_remetente
                                                .nome_remetente
                                        }} </b
                                    ><br />
                                    <small class="text-muted"
                                        >Função:
                                        {{
                                            data.item.user_remetente
                                                .funcao_remetente
                                        }}<br />Unidade:
                                        {{
                                            data.item.user_remetente
                                                .unidade_remetente
                                        }}</small
                                    >
                                </span>
                                <span v-else>
                                    <b-badge variant="primary">
                                        Cadastrado por um Atendente
                                    </b-badge>
                                </span>
                                <br />
                                <span v-if="data.item.agent">
                                    Atendente:
                                    <b> {{ data.item.agent.name }} </b>
                                    <br />
                                </span>
                                <span v-if="data.item.department">
                                    Departamento:
                                    <b> {{ data.item.department.name }} </b>
                                    <br />
                                </span>
                            </template>
                            <template v-slot:cell(subject)="data">
                                <span
                                    class="d-inline-block text-truncate text-muted"
                                    style="max-width: 200px"
                                >
                                    {{ data.value }}
                                </span>
                            </template>
                            <template v-slot:cell(status)="data">
                                <b :style="`color: ${data.item.status.color}`">
                                    {{ data.item.status.name }}
                                </b>
                                <span v-if="data.item.priority">
                                    <br />
                                    <b> {{ data.item.priority.name }} </b>
                                </span>
                            </template>
                            <template v-slot:cell(created_at)="data">
                                <small class="text-muted">
                                    Criado em:
                                    <b>
                                        {{ data.value | formatDateHora() }}
                                    </b>
                                    <br />
                                </small>
                                <small
                                    class="text-muted"
                                    v-if="
                                        data.item.lastReply.created_at !=
                                        data.item.created_at
                                    "
                                >
                                    Última interação:
                                    <b>
                                        {{
                                            data.item.lastReply.created_at
                                                | fromNow()
                                        }}
                                    </b>
                                    <br />
                                </small>
                            </template>
                            <template v-slot:cell()="data">
                                <b-button
                                    :title="$t('Edit Suporte')"
                                    :to="
                                        '/dashboard/admin/suportes/edit/' +
                                        data.item.uuid
                                    "
                                    class="px-2 mb-0"
                                    size="xs"
                                    type="button"
                                    v-b-tooltip.hover
                                    variant="success"
                                >
                                    <i class="mdi mdi-square-edit-outline" />
                                </b-button>
                            </template>
                            <template v-slot:empty="scope">
                                <div class="text-center my-5">
                                    <img
                                        :alt="$t('No results')"
                                        class="mb-5"
                                        src="/img/icons/robot.svg"
                                        style="max-height: 165px"
                                    />
                                    <h3 class="bold">
                                        {{ $t("No records found") }}
                                    </h3>
                                </div>
                            </template>
                            <template v-slot:emptyfiltered="scope">
                                <div class="text-center my-5">
                                    <img
                                        :alt="$t('No results')"
                                        class="mb-5"
                                        src="/img/icons/robot.svg"
                                        style="max-height: 165px"
                                    />
                                    <h3>
                                        {{
                                            $t(
                                                "No records match the entered search"
                                            )
                                        }}
                                    </h3>
                                </div>
                            </template>
                        </b-table>
                    </b-card>
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group d-inline-flex mb-0">
                                <select
                                    class="form-control"
                                    style="width: 70px"
                                    v-model="perPage"
                                    v-on:change="getSuportes"
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                </select>
                            </div>
                            <div class="d-inline-flex ml-2">
                                <b-pagination
                                    :per-page="perPage"
                                    :total-rows="pagination.total"
                                    @change="changePage"
                                    v-model="page"
                                />
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                            <div class="float-lg-right">
                                {{ $t("Showing page") }}
                                {{ pagination.currentPage }} {{ $t("of") }}
                                {{ pagination.totalPages }} {{ $t("pages in") }}
                                {{ pagination.total }}
                                {{ $t("records") }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "Suportes",
    metaInfo() {
        return {
            title: this.$i18n.t("Suportes"),
        };
    },
    data() {
        return {
            page: 1,
            filters: {
                search: "",
                departments: [],
                statuses: [],
                remetente: "",
                data_inicio: "",
                data_fim: "",
            },
            perPage: 10,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            sort: {
                order: "desc",
                column: "updated_at",
            },
            suportesList: [],
            departmentList: [],
            statusesList: [],
            solicitantes: [],
            loading: false,
            disabledStatus: false,
            disabledDepartamentos: false,
            filter: false,
            app_suporte_email: "",
            app_suporte_password: "",
            app_suporte_url: "",
            datas: [],
            url_app_suporte: "",
        };
    },
    computed: {
        departamentos() {
            const departamentos = this.departmentList;

            const map = departamentos.map((elem) => ({
                id: elem.id,
                value: elem.name,
            }));
            return map;
        },
        status() {
            const status = this.statusesList;

            const map = status.map((elem) => ({
                id: elem.id,
                value: elem.name,
            }));
            return map;
        },
    },
    mounted() {
        this.url_app_suporte = this.$store.state.settings.app_suporte_url;
        if (localStorage.getItem("token_suporte")) {
            this.$store.dispatch("setLoginSuporte");
            this.getSuportes();
            this.getDepartments();
            this.getStatus();
            this.getSolicitantes();
        } else {
            this.loginSuporte();
        }
    },
    methods: {
        loginSuporte() {
            this.loading = true;
            axios
                .post(
                    this.$store.state.settings.app_suporte_url +
                        "api/auth/login",
                    {
                        email: this.$store.state.settings.app_suporte_email,
                        password:
                            this.$store.state.settings.app_suporte_password,
                    }
                )
                .then((response) => {
                    localStorage.setItem("token_suporte", response.data.token);
                    this.loading = false;
                    this.getSuportes();
                    this.getDepartments();
                    this.getStatus();
                    this.getSolicitantes();
                })
                .catch(() => {
                    this.$router.push("/dashboard/home");
                });
        },
        changeSort() {
            if (this.sort.order === "asc") {
                this.sort.order = "desc";
            } else if (this.sort.order === "desc") {
                this.sort.order = "asc";
            }
            this.getSuportes();
        },
        // Change the page
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getSuportes();
            }
        },

        // Get roles list
        getSuportes() {
            this.loading = true;
            if (this.data_inicio) {
                this.filters.data_inicial = this.$options.filters.formatDateYMD(
                    this.data_inicio
                );
            }
            if (this.data_fim) {
                this.filters.data_final = this.$options.filters.formatDateYMD(
                    this.data_fim
                );
            }

            if (this.$route.query.me) {
                this.filters.remetente = parseInt(this.$route.query.me);
                this.viewFilterReport = true;
            }
            axios
                .get(this.url_app_suporte + "api/tickets", {
                    params: {
                        page: this.page,
                        sort: this.sort,
                        perPage: this.perPage,
                        search: this.filters.search,
                        departments: this.filters.departments,
                        statuses: this.filters.statuses,
                        remetente: this.filters.remetente,
                        data_inicial: this.filters.data_inicial,
                        data_final: this.filters.data_final,
                    },
                    headers: {
                        Authorization:
                            "Bearer " + localStorage.getItem("token_suporte"),
                    },
                })
                .then((response) => {
                    this.datas = response.data.datas;
                    this.suportesList = response.data.items;
                    this.loading = false;
                    this.pagination = response.data.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getSuportes();
                    } else {
                        this.loading = false;
                    }
                })
                .catch((error) => {
                    this.$snack.success({
                        button: false,
                        text: error.response.data,
                    });
                    this.loading = false;
                });
        },

        getDepartments() {
            const self = this;
            self.disabledDepartamentos = true;
            axios
                .get(this.url_app_suporte + "api/tickets/departments", {
                    headers: {
                        Authorization:
                            "Bearer " + localStorage.getItem("token_suporte"),
                    },
                })
                .then(function (response) {
                    self.departmentList = response.data;
                    self.disabledDepartamentos = false;
                });
        },

        getStatus() {
            const self = this;
            self.disabledStatus = true;
            axios
                .get(this.url_app_suporte + "api/tickets/statuses", {
                    headers: {
                        Authorization:
                            "Bearer " + localStorage.getItem("token_suporte"),
                    },
                })
                .then(function (response) {
                    self.statusesList = response.data;
                    self.disabledStatus = false;
                });
        },
        getSolicitantes() {
            const self = this;
            axios
                .get(this.url_app_suporte + "api/tickets/remetentes", {
                    headers: {
                        Authorization:
                            "Bearer " + localStorage.getItem("token_suporte"),
                    },
                })
                .then(function (response) {
                    self.solicitantes = response.data;
                });
        },
        limparFiltros() {
            this.filters = {};
            this.data_inicio = "";
            this.data_fim = "";
            this.verificaDataInicial = false;
            this.getSuportes();
        },
    },
};
</script>
